import { createSearchParams, Link, useNavigate } from 'react-router-dom';
import { IIncomingOffer } from '../../types/business-offer';
import styles from './index.module.sass';
import allowSvg from '@@/offer/images/check.svg';
import grainIcon from '@@/offer/images/grain.icon.svg';
import trashSvg from '@@/offer/images/trash.svg';
import { ButtonMain } from '@/modules/common/components/button';
import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import {
  compareDateWithCurrentTime,
  getRemainingMinutes,
} from '@/modules/common/helpers/compare-date.helper';
import { multiApproveBusinessOffers } from '../../functions/multi-approve.function';
import infoIconRed from '@@/offer/images/info-red.svg';
import infoIconYellow from '@@/offer/images/info-yellow.svg';
import { notification, Tooltip } from 'antd';
import { $selectedOffers, setSelectedOffers } from '../../store/offer-page.store';
import {
  TRADE_OFFER_NOT_ACTUAL_OFFSET_BEFORE_EXPIRATION_MINUTES,
  TRADE_OFFER_PRE_EXPIRATION_MINUTES,
} from '@/modules/common/constants/trade-offers.constant';
import { ParamsSection } from './components/params-section/index.component.';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { CompAdditional } from '@/modules/common/components/mix-item/components/mixes-tooltip';
import { warehouseModel } from '@/entities/warehouse';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import { WarehouseTypes } from '@/modules/warehouses/ts';
import {
  PURCHASE_PRICE_WITHOUT_VAT,
  WITHOUT_VAT,
} from '@/shared/constants/price.constants';

export const OfferProItem = ({
  data,
  checked,
  onChange,
  deleteFoo,
}: {
  checked: boolean;
  onChange: () => void;
  data: IIncomingOffer;
  deleteFoo: () => void;
}) => {
  const culturesList = useStore($agriculture);
  const selectedOffers = useStore($selectedOffers);
  const name = culturesList.find((item) => item.id === data.agriculture_ids?.[0])?.name;
  const expirationOffset = TRADE_OFFER_NOT_ACTUAL_OFFSET_BEFORE_EXPIRATION_MINUTES;
  const preExpirationOffset = TRADE_OFFER_PRE_EXPIRATION_MINUTES;
  const isWarehouseTypeSleeve =
    data?.warehouse_type &&
    (Number(data.warehouse_type) as unknown as WarehouseTypes) ===
      warehouseModel.WAREHOUSE_TYPES.sleeve;
  const [deadline, setDeadline] = useState(
    compareDateWithCurrentTime(data.expiration_date),
  );
  const [remainingMinutes, setRemainingMinutes] = useState(
    getRemainingMinutes(data.expiration_date),
  );
  const navigate = useNavigate();

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const minutesLeft = getRemainingMinutes(data.expiration_date);
  //     setDeadline(compareDateWithCurrentTime(data.expiration_date));
  //     setRemainingMinutes(minutesLeft);
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const minutesLeft = getRemainingMinutes(data.expiration_date);
    setDeadline(compareDateWithCurrentTime(data.expiration_date));
    setRemainingMinutes(minutesLeft);
    const interval = setInterval(() => {
      const minutesLeft = getRemainingMinutes(data.expiration_date);
      setDeadline(compareDateWithCurrentTime(data.expiration_date));
      setRemainingMinutes(minutesLeft);
    }, 3000);
    return () => clearInterval(interval);
  }, [data]);

  console.log(remainingMinutes);

  return (
    <div className={styles.root}>
      <div className={styles.main}>
        <div
          className={styles.topInformation}
          style={
            remainingMinutes < preExpirationOffset && remainingMinutes >= 0
              ? { backgroundColor: '#FDF8E2' }
              : remainingMinutes < expirationOffset
              ? { backgroundColor: '#FFEAEB' }
              : undefined
          }
        >
          <div className={styles.leftSide}>
            <span className={styles.buyerName}>{data.company_name}</span>
            <span
              className={styles.buyerType}
              style={
                remainingMinutes < preExpirationOffset && remainingMinutes >= 0
                  ? { color: '#E1B401' }
                  : remainingMinutes < expirationOffset
                  ? { color: '#000' }
                  : undefined
              }
            >
              {data.external ? 'внешний контрагент' : 'внутренний контрагент'}
            </span>
          </div>
          <div className={styles.rightSide}>
            <div className={styles.requisite}>
              <span className={styles.label}>срок предложения</span>
              <span className={styles.val}>
                {remainingMinutes < preExpirationOffset && remainingMinutes >= 0 ? (
                  <b
                    style={{
                      color: '#E1B401',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {deadline}
                    <Tooltip title={'у предложения покупателя истекает срок действия'}>
                      <img style={{ cursor: 'pointer' }} src={infoIconYellow} />
                    </Tooltip>
                  </b>
                ) : remainingMinutes < expirationOffset ? (
                  <b
                    style={{
                      color: '#E73A42',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    истек{' '}
                    <Tooltip title={'обновите срок предложения покупателя'}>
                      <img style={{ cursor: 'pointer' }} src={infoIconRed} />
                    </Tooltip>
                  </b>
                ) : (
                  deadline
                )}
              </span>
            </div>
            <div className={styles.requisite}>
              <span className={styles.label}>{PURCHASE_PRICE_WITHOUT_VAT}</span>
              <span className={styles.val}>
                {(+data.price).toLocaleString('ru', { maximumFractionDigits: 0 })} ₽/т
              </span>
            </div>
          </div>
        </div>
        <div className={styles.midInformation}>
          <div className={styles.leftSide}>
            <div className={styles.grainWrap}>
              <img src={grainIcon} className={styles.grain} />
            </div>
            <div className={styles.requisite}>
              <span className={styles.bold}>
                {name || 'культура не определена'}, {data.wheat_class}
              </span>
              <span className={styles.val}>
                {spreadWheatType(Number(data.wheat_type))?.sort}{' '}
                {spreadWheatType(Number(data.wheat_type))?.type}
              </span>
            </div>
          </div>
          <div className={styles.rightSide}>
            <div className={styles.requisite}>
              <span className={styles.label}>вес</span>
              <span className={styles.val}>
                {(+data.weight + +data.weight_gain_tons).toLocaleString('ru', {
                  maximumFractionDigits: 2,
                })}{' '}
                т
              </span>
            </div>
            <div className={styles.requisite}>
              <span className={styles.label}>стоимость логистики</span>
              <span className={styles.val} style={{ textAlign: 'left' }}>
                {(+data.price_logistic).toLocaleString('ru', {
                  maximumFractionDigits: 0,
                })}{' '}
                ₽
              </span>
            </div>
            <div className={styles.requisite}>
              <span className={styles.label}>стоимость {WITHOUT_VAT}</span>
              <span className={styles.val}>
                {Number(data.price_all)?.toLocaleString('ru', {
                  maximumFractionDigits: 0,
                }) || 0}{' '}
                ₽
              </span>
            </div>
          </div>
        </div>
        <ParamsSection data={data} />
        <div className={styles.actionBar}>
          <div className={styles.side}>
            {data.action === 'mix' ? (
              <>
                <span className={styles.tag}>миксование</span>
                {data.components && (
                  <CompAdditional
                    idx={1}
                    buyer={[
                      data.components[0]?.buyer_company,
                      data.components[1]?.buyer_company,
                    ]}
                    qty={[
                      data.components[0]?.sleeves_count,
                      data.components[1]?.sleeves_count,
                    ]}
                    price={[
                      data.components[0]?.price_all,
                      data.components[1]?.price_all,
                    ]}
                    pricePerTon={[
                      data.components[0]?.price_per_ton,
                      data.components[1]?.price_per_ton,
                    ]}
                    distance={[
                      data.components[0]?.distance,
                      data.components[1]?.distance,
                    ]}
                    netto={[
                      data.components[0]?.price_netto,
                      data.components[1]?.price_netto,
                    ]}
                    weight={[data.components[0]?.weight, data.components[1]?.weight]}
                    priceLogistic={[
                      data.components[0]?.price_logistic,
                      data.components[1]?.price_logistic,
                    ]}
                  />
                )}
                <Link
                  to={
                    Array.isArray(data.bunkerreloaders_ids) &&
                    data.bunkerreloaders_ids.length > 0
                      ? `/mixing/recipe/detail/${data.mix_id}?warehouse_id=${
                          data.warehouse_id
                        }&bunker=${JSON.stringify(
                          data.bunkerreloaders_ids,
                        )}&viewOnly=true`
                      : `/mixing/mixer/${data.mix_id}?viewOnly=true`
                  }
                  className={styles.showRecipeAction}
                >
                  показать рецепт
                </Link>
              </>
            ) : data.action === 'hydrate' ? (
              <span className={styles.tag} style={{ backgroundColor: '#C8E7FF' }}>
                увлажнение
              </span>
            ) : data.action === 'drain' ? (
              <span style={{ background: 'rgb(255, 234, 235)' }} className={styles.tag}>
                осушение
              </span>
            ) : (
              ''
            )}
            <div className={styles.sleeve}>
              <span>{data.warehouse_name}</span>
              {data.action !== 'mix' ? (
                <b>{`${isWarehouseTypeSleeve ? 'рукав' : 'объём'} ${
                  data?.items?.[0].bag_id
                }`}</b>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className={styles.side}>
            <a
              className={styles.deleteAction}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                deleteFoo();
              }}
            >
              <img src={trashSvg} className={styles.icon} />
              удалить сделку
            </a>
            {data.destination_id ? (
              <ButtonMain
                label="логистика"
                active={!(remainingMinutes < expirationOffset)}
                onClick={() => {
                  if (remainingMinutes < expirationOffset)
                    return notification.warning({
                      message: 'обновите срок предложения покупателя для сделки',
                    });
                  navigate({
                    pathname: '/mixing/logistics/management',
                    search: createSearchParams({
                      trade_id: String(data.id),
                      destination_id: String(data.destination_id),
                      warehouse_id: String(data.warehouse_id),
                    }).toString(),
                  });
                }}
                className={styles.showLogisticAction}
              />
            ) : (
              <span className={styles.pickup}>самовывоз</span>
            )}
            <ButtonMain
              label="оформить сделку"
              active={remainingMinutes >= expirationOffset}
              onClick={async () => {
                if (remainingMinutes < expirationOffset)
                  return notification.warning({
                    message: 'обновите срок предложения покупателя для сделки',
                  });
                await multiApproveBusinessOffers([data.id]);
                navigate('/offer/contracts');
              }}
              className={styles.createBusinessOfferAction}
            />
          </div>
        </div>
      </div>
      <div className={styles.interactive}>
        <div className={styles.check} aria-checked={checked} onClick={() => onChange()}>
          <img className={styles.checkImg} src={allowSvg} />
        </div>
      </div>
    </div>
  );
};
